// extracted by mini-css-extract-plugin
module.exports = {"rooms_list":"ShowroomsList_rooms_list__2nT0_","rooms__single":"ShowroomsList_rooms__single__25gdh","rooms__single_image":"ShowroomsList_rooms__single_image__2qJk2"};